export default {
  data: () => ({
    documentation: {
      areaReport: 'kb/narzedzia/raport-o-terenie',
      communeGeneralPlan: 'kb/narzedzia/plan-ogolny-gminy',
      databoxData: 'kb/data-box/narzedzie-pobierz-dane-wektorowe',
      databoxData2: 'kb/data-box/narzedzie-pobierz-dane-wektorowe',
      dynamicBuffer: 'kb/data-box/narzedzie-dynamiczne-buforowanie',
      ozeAreaSearch: 'kb/data-box/narzedzie-wyszukiwarka-terenow-inwestycyjnych',
      routingService: 'kb/narzedzia/wyznaczanie-tras',
      usableArea: 'kb/narzedzia/powierzchnia-uzytkowa',
      parcelsSearch: 'kb/narzedzia/wyszukiwarka-dzialek',
      advancedAreaSearch: 'kb/data-box/zaawansowana-wyszukiwarka-terenow-inwestycyjnych',
      heatmap: 'kb/narzedzia/mapa-ciepla',
    },
  }),
};
